<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ date }}
        </p>
        <p>
            <template v-if="lodash.isEmpty(attorneyGeneral.name)">
                [Your State Attorney General]
            </template>
            <template v-else>
                {{ attorneyGeneral.name }}
            </template>
            <br />
            <template v-if="lodash.isEmpty(consumerDivisionName)">
                [Consumer Division Name]
            </template>
            <template v-else>
                {{ consumerDivisionName }}
            </template>
            <br />
            <template v-if="lodash.isEmpty(attorneyGeneral.address)">
                [Atty. General’s Street Address]
            </template>
            <template v-else>
                {{ attorneyGeneral.address }}
            </template>
            <br />
            <template
                v-if="
                    lodash.isEmpty(attorneyGeneral.city)
                    &&
                    lodash.isEmpty(attorneyGeneral.state)
                    &&
                    lodash.isEmpty(attorneyGeneral.zipcode)
                "
            >
                [Atty. General’s City, State Zip]
            </template>
            <template v-else>
                {{ attorneyGeneral.city }}, {{ attorneyGeneral.state }} {{ attorneyGeneral.zipcode }}
            </template>
        </p>
        <p>
            <template v-if="lodash.isEmpty(attorneyGeneral.fax)">
                VIA FAX [fax # to consumer div of your state Atty. Gen.’s Office; delete if none]
            </template>
            <template v-else>
                VIA FAX  {{ attorneyGeneral.fax }}
            </template>
        </p>
        <p>
            <b>
                Re:	Consumer Complaint Against {{ creditor.creditor_name }}
            </b>
        </p>
        <p>
            Dear {{ attorneyGeneral.name }}:
        </p>
        <p>
            My full name is {{ userStore.user.firstname }} {{ userStore.user.lastname }}. My email is {{ userStore.user.email }}. My Social Security # is {{ userStore.user.ssn }}. My date of birth is {{ userStore.user.dob }}. Please process my following letter as a complaint against {{ creditor.creditor_name }}. Please investigate the issue and provide me with copies of any responses you receive. Thank you for your attention to this matter and all that you do for consumers alike. 
        </p>
        <p style="page-break-after: always;">
            Sincerely,
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../../../stores/UserStore.js'
    import { useReportStore } from '../../../../stores/ReportStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        name: 'AttorneyGeneralLetter1',
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            },
            consumerDivisionName: {
                type: [Array, Object]
            },
            attorneyGeneral: String
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                lodash: lodash
            };
        }
    };
</script>